import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import propTypes from 'prop-types';
import {Col} from 'reactstrap';
import {TextRupiah} from '../../../Text';

export default class PayAmount extends Component{
    render(){
        return(
            <Col xs={12} md={12} className="section">
                {/* <p>Jumlah tertagih:</p> */}
                <div className="amount">
                    <h5 style={{marginBottom:0}}>
                        <TextRupiah 
                            prefix="IDR. " 
                            block 
                            value={this.props.total} 
                            align="center"
                        />
                    </h5>
                </div>
            </Col>
        )
    }
}

PayAmount.propTypes={
    total:propTypes.string.isRequired
}